module.exports = __webpack_public_path__ + "static/media/sullivan_serious.3630deae.png";